import { User } from '@/store/security/types'

export function isAuthenticated(user: User): boolean {
  return !!user &&
    !!user.BearerToken &&
    !sessionExpired(user)
}

function sessionExpired(user: User) : boolean {
  if (!user.BearerToken ||
    user.BearerToken === '' ||
    !user.TokenExpiration) return true

  return Date.now() >= (user.TokenExpiration * 1000)
}
